// extracted by mini-css-extract-plugin
export default {"notify":"notify_notify__ymOqQ","info":"notify_info__oMSb9","warning":"notify_warning__MGFAh","error":"notify_error__F89Jb"};